import React from 'react'
import CookieBanner, {
  Cookies,
  CookiesProvider,
  CookieBannerUniversal,
} from 'react-cookie-banner'

const cookies = new Cookies('ct-cookies-accepted')

class Cookie extends React.Component {
  state = {
    ready: false,
  }

  componentDidMount() {
    this.setState({ ready: true })
  }

  render() {
    const { ready } = this.state

    if (ready) {
      const cookieset = cookies.get('ct-cookies-accepted') || false
      if (!cookieset) {
        return (
          <CookieBannerUniversal
            message="This site uses cookies for a better experience, just scroll down to dismiss"
            onAccept={() => {}}
            cookie="ct-cookies-accepted"
            styles={{
              button: { display: 'none' },
              banner: {
                backgroundColor: 'rgba(72, 72, 72,.8)',
                height: 100,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
              message: {
                padding: '3rem',
                lineHeight: 1.5,
                fontFamily: 'sans-serif',
                fontSize: '1.2rem',
              },
            }}
          />
        )
      } else {
        return null
      }
    } else {
      return null
    }
  }
}

export default Cookie



// WEBPACK FOOTER //
// ./src/components/cookie/index.js